import { useEffect, useState} from 'react';
import axios from 'axios';


const useGetALLFechaAdmision = (token) => {
    const [getALLFechasAdmision, setALLfechasAdmision] = useState([]);

    useEffect(() => {
        const data = async () => {
            const form_data = new FormData();
            form_data.append('idToken', token);
            const response = await axios.post(process.env.REACT_APP_API_URL+'?getALLFechaAdmisionElegida=true', form_data); //getALLFechaAdmisionElegida
            setALLfechasAdmision(response.data);
        }
        data()
            .catch(console.error);
    }, [token]); 
    return getALLFechasAdmision;
}

export default useGetALLFechaAdmision;